<script>
  import { auth } from "../firebase";
  import Login from "./Login.svelte";
  import Register from "./Register.svelte";
  import ForgotPassword from "./ForgotPassword.svelte";
  import { fly, fade } from 'svelte-transitions';

  $: form = "login";

  function showLogin(event) {
    form = "login";
  }
  function showRegister(event) {
    form = "register";
  }
  function showForgotPassword(event) {
    form = "forgotPassword"
  }
</script>

<style>
  .auth-container {
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }
</style>

<div class="auth-container">
  {#if form === 'register'}
    <div in:fade={{duration: 500}}>
      <Register on:login={showLogin} />
    </div>
  {:else if form === 'login'}
    <div in:fade={{duration: 500}}>
      <Login on:register={showRegister} on:forgotPassword={showForgotPassword} />
    </div>
  {:else if form === 'forgotPassword'}
    <div in:fade={{duration: 500}}>
      <ForgotPassword on:login={showLogin}/>
    </div>
  {/if}
</div>
